export default function header() {
  const summary = document.querySelector('.credits__summary');
  const details = document.querySelectorAll('.credits__details');

  if (summary && details) {
    summary.addEventListener('click', (event) => {
      event.preventDefault();

      details.forEach((element) => {
        element.classList.toggle('d-block');
      });
    });
  }
}
